export default __webpack_public_path__ + "static/media/logo-Via-Maria.f77998df.png";